<template>
  <div class="file-modal-border">
    <app-modal
      :modal-id="modalId"
      modal-alignment="top"
      modal-size="extra-large"
      data-backdrop="static"
      data-keyboard="false"
      style="background:rgba(0, 0, 0, .5)"
      >
      <template slot="header">
        <!-- <div class="d-flex"> -->
        <!-- <app-icon name="upload-cloud"/> -->
        <h5 class="modal-title ml-5" style="font-size: 1.25rem; color: black">
          {{ $t("Files") }}
        </h5>
        <!-- </div> -->

        <!-- <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button> -->
      </template>
      <template slot="body">
        <div class="card card-with-search border-0">
          <div class="text-justify">
            <app-tab :tabs="tabsHorizontal" type="horizontal" />
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          type="button"
          class="btn btn-primary mr-2"
          data-dismiss="modal"
          @click="closeModal"
        >
          {{ $t("close") }}
        </button>
      </template>
    </app-modal>
  </div>
</template>

<script>
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";

export default {
  name: "File",
  extends: CoreLibrary,
  mixins: [ModalMixin],
  props: {
    tableId: String,
    id: Number,
    textvalue: Function, //SET ON GALLERY PROPS  Func: this.textvalue,
    componentId: String,
  },
  data() {
    return {
      modalId: "file_modal",
      icon: "settings",
      isAddEditModalActive: false,
      tabsHorizontal: [
        {
          icon: "file",
          name: "Files",
          component: "file-gallery",
          permission: "",
          props: { Func: this.textvalue, componentId: this.componentId },
        },
        {
          icon: "file-plus",
          name: "File Upload",
          component: "file-upload",
          permission: "",
        },
      ],
    };
  },
  methods: {
    ChangeT(title) {
      
    },
  },
  mounted() {
    // $(function () {
    //   $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    // });
  }
};
</script>
<!-- <style >
 .file-modal-border .modal .modal-dialog.modal-dialog-top{
  border: solid #4466f2 0.5px !important;
}
</style> -->